import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import gql from 'graphql-tag';

export const fetchCategoriesQuery = gql`
  query SearchAllCategories {
    taxonomy_category {
      id
      mdm_code
      mdm_name
    }
    defaultCatalog: taxonomy_category(where: { is_actived: { _eq: true } }) {
      id
      mdm_code
      mdm_name
    }
  }
`;
export const searchCategoriesQuery = gql`
  query SearchCategories  ($keyword: String){
    taxonomy_category 
    (where: {_or: [{mdm_name: {_ilike: $keyword}}, {mdm_code: {_ilike: $keyword}}]}) {
      id
      mdm_code
      mdm_name
    }
  }
`;

const category = {
  namespaced: true,
  state: {
    categories: [],
    categoriesSearched: [],
  },
  actions: {
    async fecthAll({ commit }) {
      try {
        const requestQuery = {
          query: fetchCategoriesQuery,
        };

        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_CATEGORIES', result.data);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async search({ commit }, keyword) {
      try {
        const requestQuery = {
          query: searchCategoriesQuery,
          variables: {
            keyword: `${keyword}%`,
          },
        };

        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_CATEGORIES_SEARCHED', result.data.taxonomy_category);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
  },
  mutations: {
    SET_CATEGORIES(state, data) {
      Vue.set(state, 'categories', data.taxonomy_category);
    },
    SET_CATEGORIES_SEARCHED(state, data) {
      Vue.set(state, 'categoriesSearched', data);
    },
  },
  getters: {
    categoriesInfo: state => state.categories,
    categoriesSearchedInfo: state => state.categoriesSearched,
  },
};

export default category;



// WEBPACK FOOTER //
// ./src/store/modules/core/category.js